import { render, staticRenderFns } from "./HeaderUserType.vue?vue&type=template&id=45550135&scoped=true&"
import script from "./HeaderUserType.vue?vue&type=script&lang=js&"
export * from "./HeaderUserType.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserType.vue?vue&type=style&index=0&id=45550135&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45550135",
  null
  
)

export default component.exports